import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[uppercase]',
    standalone: false
})
export class UpperDirective {


  constructor(private _el: ElementRef, private readonly ngControl: NgModel) { }

  
  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value.toUpperCase();
    //this._el.nativeElement.value = initalValue;
    this.ngControl.control.setValue(initalValue,{ 
      emitEvent: false,
      emitModelToViewChange: false,
      emitViewToModelChange: false})
    if ( initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
      
  }

}